import { BaseService } from "./baseService";
class TempWorkshiftService extends BaseService {
    constructor() {
        super(...arguments);
        this.controllerName = "temporal_workshift";
    }
}
export const tempWorkshiftService = new TempWorkshiftService();
//# sourceMappingURL=tempWorkshiftService.js.map